// extracted by mini-css-extract-plugin
module.exports = {"container":"CollectPaymentData_container___k_ZZ"};